import Entities from './shared/Entities';
import { createScrollObserver } from './shared/ScrollTrigger';

import { setAttr } from '../helpers/dom';
import { EVENT } from '../helpers/transition';

const DELAY_OFFSET = 120;
const MAX_DELAY_OFFSET = 1600;

export default class ScrollEnter {
  static delay = 0;

  constructor() {
    this.entities = new Entities(
      'ScrollEnter',
      '[data-scroll-enter]',
      ScrollEnter.initSingle,
      ScrollEnter.destroySingle,
    );
  }

  static initSingle(containerEl) {
    const mainEl = containerEl;
    const rangeEl = ScrollEnter.getRangeEl(containerEl);
    const isReset = containerEl.getAttribute('data-scroll-enter-reset') !== null;

    let entered = false;

    function onAnimEnd() {
      mainEl.removeEventListener(EVENT.END, onAnimEnd);
      mainEl.removeEventListener(EVENT.CANCEL, onAnimEnd);
      setAttr(mainEl, 'data-scroll-enter', null);
    }

    function enter() {
      scrollObserver.unobserve();

      if (isReset) {
        ScrollEnter.delay = 0;
        setAttr(mainEl, 'data-entered', '');
        onAnimEnd();
        return;
      }

      setTimeout(() => {
        mainEl.addEventListener(EVENT.END, onAnimEnd);
        mainEl.addEventListener(EVENT.CANCEL, onAnimEnd);
        setAttr(mainEl, 'data-entered', '');

        ScrollEnter.delay -= DELAY_OFFSET;
        if (ScrollEnter.delay < 0) ScrollEnter.delay = 0;
      }, Math.min(ScrollEnter.delay, MAX_DELAY_OFFSET));

      ScrollEnter.delay += DELAY_OFFSET;
    }

    function tryEnter() {
      if (!entered) return;

      const isVisible = mainEl?.checkVisibility?.({ checkVisibilityCSS: true }) ?? true;
      if (!isVisible) return;

      enter();
    }

    function onEnter() {
      entered = true;
      tryEnter();
    }

    function onScroll() {
      tryEnter();
    }

    const scrollObserver = createScrollObserver(rangeEl, { onEnter, onScroll });
    scrollObserver.observe();

    function destroy() {
      // scrollObserver.unobserve();
      scrollObserver.destroy();
      onAnimEnd();
    }

    return {
      destroy,
    };
  }

  static getRangeEl(containerEl) {
    const rangeEl = containerEl.querySelector('[data-scroll-enter-range]');
    if (rangeEl !== null && rangeEl.closest('[data-scroll-enter]') === containerEl) return rangeEl;
    return containerEl;
  }

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }
}